import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/Login.css';
import { FaEye, FaEyeSlash } from 'react-icons/fa'; // 👁️ Import icons

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showEmployeePassword, setShowEmployeePassword] = useState(false);
  const [showInternPassword, setShowInternPassword] = useState(false);

  const navigate = useNavigate();

  // Auto-detect base URL
  const BASE_URL = window.location.origin.includes('localhost')
    ? 'http://localhost:5000'
    : `${window.location.origin}`;

  // 🧑‍💼 Employee Login
  const handleEmployeeLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${BASE_URL}/api/employees/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        navigate('/employee-dashboard');
      } else {
        alert(data.message || 'Invalid credentials');
      }
    } catch (error) {
      console.error('Employee login error:', error);
      alert('Error during login. Please try again.');
    }
  };

  // 🎓 Intern Login
  const handleInternLogin = async (e) => {
    e.preventDefault();

    const email = document.getElementById('intern-email').value;
    const password = document.getElementById('intern-password').value;

    try {
      const response = await fetch(`${BASE_URL}/api/intern/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        // ✅ Save intern email
        localStorage.setItem('internEmail', data.intern.email);

        // Navigate to dashboard
        navigate('/intern-dashboard');
      } else {
        alert(data.message || 'Invalid credentials');
      }
    } catch (error) {
      console.error('Intern login error:', error);
      alert('Error during login. Please try again.');
    }
  };


  return (
    <div className="login-wrapper">
      <div style={{ width: '100%', marginBottom: '20px' }}>
        <Link to="/" className="back-home-link">← Back to Home</Link>
      </div>

      {/* Employee Login Section */}
      <div className="login-card">
        <h2>Employee Login</h2>
        <form className="login-form" onSubmit={handleEmployeeLogin}>
          <label htmlFor="employee-username">Username / Email</label>
          <input
            type="text"
            id="employee-username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Enter your username"
            required
          />

          <label htmlFor="employee-password">Password</label>
          <div className="password-field">
            <input
              type={showEmployeePassword ? 'text' : 'password'}
              id="employee-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
            />
            <span
              className="eye-icon"
              onClick={() => setShowEmployeePassword(!showEmployeePassword)}
            >
              {showEmployeePassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          <button type="submit">Login</button>
        </form>
        <p className="register-link">
          Not registered? <Link to="/employee-register">Register here</Link>
        </p>
      </div>

      {/* Intern Login Section */}
      <div className="login-card">
        <h2>Intern Login</h2>
        <form className="login-form" onSubmit={handleInternLogin}>
          <label htmlFor="intern-email">Email</label>
          <input type="email" id="intern-email" placeholder="Enter your email" required />

          <label htmlFor="intern-password">Password</label>
          <div className="password-field">
            <input
              type={showInternPassword ? 'text' : 'password'}
              id="intern-password"
              placeholder="Enter your password"
              required
            />
            <span
              className="eye-icon"
              onClick={() => setShowInternPassword(!showInternPassword)}
            >
              {showInternPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          <button type="submit">Login</button>
        </form>
        <p className="register-link">
          Not registered? <Link to="/register">Register here</Link>
        </p>
      </div>
    </div>
  );
}

export default Login;
